let View = require('views/view')
let app = require('application')

module.exports = View.extend({
  template: require('views/templates/user/user-profile'),
  events () { // On récupère ici les events de view (les event globaux) pis on ajoute les spécifiques a cette vue (SOURCE : http://stackoverflow.com/questions/9403675/backbone-view-inherit-and-extend-events-from-parent)
    return _.extend({}, View.prototype.events, {
    })
  },
  getRenderData () {
    return {
      user: this.session.user
    }
  },
  afterRender() {
    this.rendered = true

    app.initDateTimepickers()

    app.select2('#id_pays-ui', {
      ajax: {
        url: '/pays',
        type: 'GET',
        data: 'no-limit=1',
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            q: params.term
          }
        },
        processResults: function (data) {
          return {
            results: $.map(data, ({pays, id_pays}) => ({ id: id_pays, text: `${pays}` }))
          }
        }
      },
      minimumInputLength: 1
    })

    app.validator('user-profile-form', [
      { name: 'nom', display: 'Nom', rules: 'required' },
      { name: 'prenom', display: 'Prénom', rules: 'required' },
      { name: 'email', display: 'Email', rules: 'valid_email|required' },
      { name: 'pwd', display: 'Mot de passe', rules: 'pwdTyp1' },
      { name: 'pwd-confirm', display: 'Confirmation de mot de passe', rules: 'matches[pwd]' },
      { name: 'birth', display: 'Date de naissance', rules: 'less_than_date[aujourd\'hui]' }
    ], this.saveInfos.bind(this))
  },
  saveInfos () {
    console.log('fuck')
    app.modalWait()

    let data = $('#user-profile-form').serialize()

    app.ajax({
      url: '/user/setProfile',
      type: 'PUT',
      data,
      complete: app.onComplete({
        success: (res) => {
          $('#success-box').html('Les modifications ont bien été prises en compte.')
        },
        complete: () => {
          app.modalWait('close')
        }
      })

    })
  }
})
